module.exports = __webpack_public_path__ + "static/media/none.6a3c2a34.svg";